import { useState, useEffect, React } from 'react';
import './App.css';

function App() {

    const [gameList, setGameList] = useState([]); 

    useEffect(() => { callAPI(); }, []);

    const callAPI = () => {
        fetch("http://localhost:9000/games")
            .then(res => res.text())
            .then(res => { setGameList(JSON.parse(res)) });
    }

    return (
    <div className="App">
            <header className="App-header"><p>Games</p>
                {gameList.map(function (record, index) {
                    var date = new Date(record.start_date);
                    return(
                        <table>
                            <tr>
                                <td>
                                    {record.away_team}
                                </td>
                                <td>
                                    {date.toLocaleDateString()}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    @
                                </td>
                                <td>
                                    {date.toLocaleTimeString()}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {record.home_team}
                                </td>
                            </tr>
                        </table>);                    
                })}
      </header>
    </div>
  );
}

export default App;
